export const SetAddressData = async (data: any, dispatch: any, state: any, addressType: number) => {
  let { street, nr, bus, postal, city, country, coordinates } = data;

  // Google Maps returns postal codes with a space (e.g. "6604 LZ"); the zip-code
  // validation expects no space ("6604LZ"), so strip whitespace before using it.
  if (postal) {
    postal = postal.replace(/\s/g, "");
  }

  //*** set lat and lang */
  let lat = "";
  let lng = "";

  if (coordinates !== "") {
    [lat, lng] = coordinates
      .replace("Lat: ", "")
      .replace("Lng: ", "")
      .split(", ");
  }

  const fieldToUpdate = [
    { field: "initialLat", value: lat },
    { field: "initialLn", value: lng },
    { field: "biInitialLat", value: lat },
    { field: "biInitialLn", value: lng },
  ];

  // Filter fields based on the addressType
  const fieldsToProcess =
    addressType === 0
      ? fieldToUpdate.slice(0, 2) // First two fields
      : fieldToUpdate.slice(2);  // Remaining fields (biInitialLat and biInitialLn)

  // Iterate over the filtered array and dispatch updates
  fieldsToProcess.forEach(({ field, value }) => {
    dispatch({
      type: "UPDATE_ADDRESS_FIELD",
      field,
      value,
    });
  });

  // Match the country dropdown. Prefer the ISO code coming from Google so the
  // country still resolves when its display name differs slightly (e.g.
  // "Belgium" vs "België"); fall back to an exact, then partial, name match.
  if (country !== "") {
    const iso = (data.countryIso || "").toLowerCase();
    const name = country.trim().toLowerCase();
    const list = state.countryList || [];
    country =
      (iso &&
        list.find((option: any) => (option.iso || "").toLowerCase() === iso)) ||
      list.find((option: any) => option.label.trim().toLowerCase() === name) ||
      list.find((option: any) =>
        option.label.toLowerCase().includes(name)
      );
  }

  // If country matches, filter cities by removing prefixes and using case-insensitive comparison
  // if (country && country.value && city !== "") {
  //   city = state.cityList.find((option: any) =>
  //     option.label.toLowerCase().includes(city.toLowerCase())
  //   ) || null;
  // }
  // Build the city option from the Google result regardless of whether the
  // country matched (the address may have a city but no resolvable country).
  // Guard against an empty city so we don't create a junk "postal - " label.
  city = city ? { value: city, label: `${postal} - ${city}` } : null;

  let officialAddress = {
    street: street,
    number: nr,
    city: city,
    country: country,
    zipCode: postal,
    box: bus,
  };

  if (addressType == 0) {
    Object.entries(officialAddress).forEach(([key, value]) => {
      dispatch({
        type: "UPDATE_ADDRESS_FIELD",
        field: key,
        value: value,
      });
    });
  }

  if (state.address.sameAddress == true || addressType == 1) {
    Object.entries(officialAddress).forEach(([key, value]) => {
      const billingFieldName =
        "bi" + key.charAt(0).toUpperCase() + key.slice(1);
      dispatch({
        type: "UPDATE_ADDRESS_FIELD",
        field: billingFieldName,
        value: value,
      });
    });
  }
};
